var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChevron = function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "256 256 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448 725.333a42.667 42.667 0 0 1-30.293-12.373 42.667 42.667 0 0 1 0-60.587L558.933 512l-135.68-141.227a42.667 42.667 0 0 1 0-60.16 42.667 42.667 0 0 1 60.587 0L648.533 481.28a42.667 42.667 0 0 1 0 59.733L477.867 711.68A42.667 42.667 0 0 1 448 725.333z"
  })));
};

export default SvgChevron;